import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const handleCategoryClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            Explore 14 Product Categories
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Browse all product categories in the Hipobuy Spreadsheet. Click any category to explore products on the main store.
          </p>
        </div>

        <div className="flex overflow-x-auto gap-4 md:gap-5 pb-4 scrollbar-hide -mx-4 px-4 md:px-0 snap-x snap-mandatory"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {categories.map((cat, idx) => (
            <button
              key={cat.name}
              onClick={() => handleCategoryClick(cat.url)}
              className="flex-shrink-0 w-44 md:w-52 lg:w-56 snap-start bg-background-50 rounded-lg border border-background-200/70 p-5 hover:border-accent-300 transition-all duration-200 group text-left cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-accent-700`}></i>
              </div>
              <div className="flex items-center space-x-2 mb-1">
                <h3 className="font-semibold text-sm md:text-base text-foreground-900 whitespace-nowrap">
                  {cat.name}
                </h3>
                {cat.hot && (
                  <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                    HOT
                  </span>
                )}
              </div>
              <p className="text-xs text-foreground-400 mt-1 flex items-center space-x-1">
                <span>Explore products</span>
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-[10px]"></i>
                </span>
              </p>
            </button>
          ))}
        </div>

        <style>{`
          .scrollbar-hide::-webkit-scrollbar { display: none; }
        `}</style>
      </div>
    </section>
  );
}